import { render, staticRenderFns } from "./r-trigger-panel.vue?vue&type=template&id=3f316ef2"
import script from "./r-trigger-panel.vue?vue&type=script&lang=js"
export * from "./r-trigger-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f316ef2')) {
      api.createRecord('3f316ef2', component.options)
    } else {
      api.reload('3f316ef2', component.options)
    }
    module.hot.accept("./r-trigger-panel.vue?vue&type=template&id=3f316ef2", function () {
      api.rerender('3f316ef2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/trigger/r-trigger-panel.vue"
export default component.exports